<template>
  <div class="modal-window mas031">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.AddOkrMemeber.001","연결된 OKR에서 멤버 추가") }}</div>
      <button @click="$emit('close')" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="scroll-full">
        <div class="inner">
          <div class="info-txt small">
            {{ $i18nUtil.trans("message.AddOkrMemeber.001","연결된 OKR") }} : {{ modalInfo.okrTitle }}
          </div>

          <div class="info-txt">
            {{ $i18nUtil.trans("message.AddOkrMemeber.002","선택한 OKR에 연결된 하위 OKR이 있다면, 하위 OKR 수행자도 멤버로 추가할 수 있습니다.") }}
          </div>

          <div class="tb-list_ty2">
            <div class="tb-header clear">
              <div class="tb_num fl">
                <div class="num" v-html="$i18nUtil.trans('search.000.people','총 {cnt} 명', {cnt: okrMemberCount})">
                  <!-- 총 <b>{{ okrMemberCount }}</b>명 -->
                </div>
              </div>
            </div>
            <!-- //tb-header -->

            <v-data-table
              v-model="selected"
              :headers="headers"
              :sort-by="'userName'"
              :items="okrMemberList"
              :single-select="singleSelect"
              show-select
              hide-default-footer
              class="tb-contents"
            >
              <!-- <template v-slot:item="{ item }">
                <tr :class="item.isstate">
                  <td>
                    <input
                      type="checkbox"
                      name=""
                      :id="'ch-' + item.id"
                      :disabled="item.isstate"
                      @click="addSelected(item)"
                    /><label :for="'ch-' + item.id"></label>
                  </td>
                  <td>
                    <div class="ell-singleline" :class="item.isstate">
                      {{ item.userName }}
                    </div>
                  </td>
                  <td>
                    <div class="ell-singleline">
                      {{ item.userId }}
                    </div>
                  </td>
                  <td>
                    <div class="ell-singleline">
                      {{ item.deptName }}
                    </div>
                  </td>
                  <td>
                    <div class="ell-singleline">
                      {{ item.jobPositionName }}
                    </div>
                  </td>
                  <td>
                    <div class="ell-singleline">
                      {{ item.jobFunctionName }}
                    </div>
                  </td>
                </tr>
              </template> -->
              <template v-slot:item.userName="{ item }">
                <div class="ell-singleline" :class="item.userName">
                  {{ item.userName }}
                </div>
              </template>
              <template v-slot:item.userId="{ item }">
                <div class="ell-singleline" :class="item.userId">
                  {{ item.userId }}
                </div>
              </template>
              <template v-slot:item.deptName="{ item }">
                <div class="ell-singleline" :class="item.deptName">
                  {{ item.deptName }}
                </div>
              </template>
              <template v-slot:item.jobPositionName="{ item }">
                <div class="ell-singleline" :class="item.jobPositionName">
                  {{ item.jobPositionName }}
                </div>
              </template>
              <template v-slot:item.jobFunctionName="{ item }">
                <div class="ell-singleline" :class="item.jobFunctionName">
                  {{ item.jobFunctionName }}
                </div>
              </template>
              <template slot="no-data">
                <div class="nodata-txt-noicon">
                  <v-alert :value="true">
                    {{ $i18nUtil.trans("message.AddOkrMemeber.003","OKR멤버가 없습니다.") }}
                  </v-alert>
                </div>
              </template>
            </v-data-table>
          </div>
          <!-- //tb-list_ty2 -->

          <ul class="ref">

            <li>
              {{ $i18nUtil.trans("message.AddOkrMemeber.004","* 연결된 OKR을 해제해도 업무공유시스템의 과제/보드 멤버는 유지됩니다.") }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="addMember">
        {{ $i18nUtil.trans("title.dialog.add.member","멤버 추가") }}
      </button>
    </footer>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapMutations } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import EventBus from "@/js/eventbus/eventBus";
export default {
  components: {
    Dialog,
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState("project", ["createProjectMemberList"]), // 추가시 등록될 멤버
  },
  data() {
    return {
      projectUserList: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      singleSelect: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.user.name","이름"), align: "center", value: "userName", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.userId","아이디"), align: "center", value: "userId", sortable: false },
        { text: this.$i18nUtil.trans("entity.user.affiliation","소속"), align: "center", value: "deptName", sortable: false },
        {
          text: this.$i18nUtil.trans("entity.user.jobPositionName","직위"),
          align: "center",
          value: "jobPositionName",
          sortable: false,
        },
        {
          text: this.$i18nUtil.trans("entity.user.jobFunctionName","직책"),
          align: "center",
          value: "jobFunctionName",
          sortable: false,
        },
      ],
      okrMemberList: [],
      okrMemberCount: 0,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  created() {
    this.getOkrMemberList();
    console.log("getOkrMemberList", this.createProjectMemberList.length);
    if (this.createProjectMemberList.length > 0) {
      this.selected = this.createProjectMemberList;
    }
  },
  methods: {
    ...mapActions("modals", ["showToast"]),
    ...mapActions("modals", ["showModal"]),
    ...mapMutations("project", ["setCreateProjectMemberList"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    getOkrMemberList() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/okr/getOkrUserList",
        method: "post",
        params: {
          okrId: this.modalInfo.okrId,
          groupId: this.modalInfo.groupId,
          locale: this.$i18nUtil.getLanguage()
        },
      };

      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
          console.log(res);
          obj.okrMemberList = res.result;
          obj.okrMemberCount = obj.okrMemberList.length;
          obj.okrMemberList.forEach((item) => {
            obj.selected.push(item);
          });
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    addMember() {
      const obj = this;
      if (this.selected.length > 0) {
        let addCogroupUserList = [];
        this.selected.forEach(function (item, index, arr) {
          //console.log("item:", item);
          let jsonData = {};
          jsonData.userId = item.userId;
          jsonData.userGrade = "MEMBER";
          jsonData.userKbn = "01";
          addCogroupUserList.push(jsonData);
        });

        this.setCreateProjectMemberList(this.selected);
        this.toastInfo.message = this.$i18nUtil.trans("TB049", {
          userCnt: this.selected.length,
        });
        this.showToast(obj.toastInfo);
        this.$emit("close");
      } else {
        const modalInfo = {
          title: this.$i18nUtil.trans("title.dialog.notice","알림"),
          width: "400px",
          height: "166px",
          obj: this.$modal,
          contents: this.$i18nUtil.trans("AB042"),
          button: this.$i18nUtil.trans("button.dialog.confirm","확인"),
          component: Dialog,
        };
        this.showModal(modalInfo);
      }
    },
    addSelected(item) {
      let resultSelected = [];
      let cmd = 0;
      this.selected.forEach((value) => {
        if (value != item) {
          resultSelected.push(value);
        } else {
          cmd = 1;
        }
      });
      if (cmd == 0) {
        this.selected.push(item);
      } else {
        this.selected = resultSelected;
      }
      console.log(cmd);
      console.log(this.selected);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/AddOkrMember.vue